export class Helpers {
    /**
     * Crear un formulario para realizar envíos POST, si parámetro submit es falso
     * retorna el formulario completo.
     *
     * @param {string} url
     * @param {object} values
     * @param {string} formId
     * @param {string} method
     * @param {string} submit
     * @returns
     */
    createForm = (
        url,
        values = {},
        formId = "dinamicForm",
        method = "POST",
        submit = true,
        target = null
    ) => {
        const Form = document.createElement("form");
        const InputToken = document.createElement("input");
        Form.setAttribute("class", "_d_none dynamicForm");
        Form.setAttribute("method", method);
        Form.setAttribute("action", url);

        if (target) {
            Form.setAttribute("target", target);
        }

        const dynamicFormCount = document.querySelectorAll(".dynamicForm");

        Form.setAttribute("id", `${formId}_${dynamicFormCount.length}`);

        InputToken.setAttribute("type", "hidden");
        InputToken.setAttribute("name", "_token");
        InputToken.setAttribute("value", this.CSRF);

        Form.appendChild(InputToken);

        for (const item in values) {
            if (Array.isArray(values[item])) {
                values[item].forEach((value) => {
                    const InputForm = document.createElement("input");
                    InputForm.setAttribute("name", item + "[]");
                    InputForm.setAttribute("value", value);
                    Form.appendChild(InputForm);
                });
            } else {
                const InputForm = document.createElement("input");
                InputForm.setAttribute("name", item);
                InputForm.setAttribute("value", values[item]);
                Form.appendChild(InputForm);
            }
        }

        document.querySelector("body").appendChild(Form);

        if (submit) {
            Form.submit();
        } else {
            return Form;
        }
    };

    /**
     * Retornar el valor de un atributo de un elemento dado
     *
     * @param {*} element Identificador, clase o elemento HTML
     * @returns {string} Valor del atributo
     */
    getData = (element, attribute = "value", dom = document) => {
        if (attribute === "value") {
            return this.getElement(element, dom)?.value;
        } else {
            return this.getElement(element, dom)?.getAttribute(attribute);
        }
    };

    /**
     * Obtener el elemento objetivo
     *
     * @param {*} element Identificador, clase o elemento HTML
     * @param {Boolean} Mostrar warnings para depurar.
     * @returns {HTMLElement} Devuelve un elemento del DOM
     */
    getElement = (target, dom = document, debug = false) => {
        let element = target;

        if (this.getType(target) === "string" && dom) {
            element = dom.querySelector(target);
            if (!element && !target.match(/^\[/)) {
                target = target.replace(/([#\.])/g, "");

                if (!element) {
                    element = dom.querySelector("#" + target);
                }

                if (!element) {
                    element = dom.querySelector("." + target);
                }
            }
        }

        if (!element && debug) {
            console.warn(`No existe el elemento ${target}`);
            console.trace();
        }

        return element;
    };

    /**
     * Función que retorna el tipo de dato del argumento pasado como parámetro
     *
     * @param {*} data valor a determinar el tipo de dato
     * @returns {string} devuelve una cadena con el tipo de dato en minúscula
     */
    getType = (data) => {
        if (Array.isArray(data)) {
            return "array";
        } else if (typeof data === "object" && data !== null) {
            return "object";
        } else {
            return typeof data;
        }
    };

    CSRF = this.getData("meta[name=csrf-token]", "content");
}
